import { ROLE_PRIVILEGES } from '../common/consts';

export function getFolderPath(organizationId, projectId) {
	return `${organizationId}/${projectId}`;
}

export const getSuffix = () => {
	return '.webp';
}

export function convertToWebp(file, quality = 0.9) {
	return new Promise((resolve, reject) => {
		if (file.type === 'image/webp') {
			resolve(file);
			return;
		}
		const img = new Image();
		img.onload = () => {
			const canvas = document.createElement('canvas');
			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;
			canvas.getContext('2d').drawImage(img, 0, 0);
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						reject(new Error('WebP conversion failed'));
						return;
					}
					const baseName = file.name.replace(/\.[^.]+$/, '');
					const webpFile = new File([blob], `${baseName}.webp`, { type: 'image/webp' });
					resolve(webpFile);
				},
				'image/webp',
				quality
			);
			URL.revokeObjectURL(img.src);
		};
		img.onerror = () => {
			URL.revokeObjectURL(img.src);
			reject(new Error(`Failed to load image: ${file.name}`));
		};
		img.src = URL.createObjectURL(file);
	});
}

export function getFileNameWithSuffix(fileName) {
	let baseName = fileName;
	if (fileName.endsWith('.jpg') || fileName.endsWith('.webp')) {
		baseName = fileName.substring(0, fileName.lastIndexOf('.'));
	}
	return `${baseName}${getSuffix()}`;
}

export function formatRoleName(role) {
	return role.replace('_', ' ');
}

export function getRoleFromPrivilege(privilegeLevel) {
	return Object.keys(ROLE_PRIVILEGES).find((key) => ROLE_PRIVILEGES[key] === privilegeLevel);
}

const getDistanceBetweenTwoPoints = (point1, point2) => {
	const x1 = point1[0];
	const y1 = point1[1];
	const x2 = point2[0];
	const y2 = point2[1];

	const l1 = Math.pow(x1 - x2, 2);
	const l2 = Math.pow(y1 - y2, 2);

	return Math.sqrt(l1 + l2);
};

export const getClosestCoordinateIndex = (coordinate, coordinates) => {
	let closestCoOrdinate = ''
	let closestCoOrdinateIndex = 0;
	let minimumDistance = 99999999999;
	coordinates.forEach((currentCoordinate, index) => {
		const distance = getDistanceBetweenTwoPoints(
			coordinate,
			[currentCoordinate.latitude, currentCoordinate.longitude]
		);
		if (distance < minimumDistance) {
			minimumDistance = distance;
			closestCoOrdinate = currentCoordinate;
			closestCoOrdinateIndex = index;
		}
	});
	return { coordinate: closestCoOrdinate, index: closestCoOrdinateIndex };
};